// src/pages/CampaignDashboard/ProspectsTable.js

import React from 'react';
import ProspectsTableRow from './ProspectsTableRow';

const ProspectsTable = ({
    prospects,
    selectAll,
    selectedRows,
    onSelectAll,
    onRowSelect,
    onGenerate,
    onReview,
    onSend,
    onSendLinked,
    getStatusStyle
}) => {
    return (
        <table className="w-full">
            <thead className="bg-gray-50 sticky top-0">
                <tr>
                    <th className="px-6 py-4">
                        <input type="checkbox" checked={selectAll} onChange={onSelectAll} />
                    </th>
                    <th className="w-32 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Company</th>
                    <th className="w-32 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Industry</th>
                    <th className="w-32 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Representative</th>
                    <th className="w-90 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Content</th>
                    <th className="w-48 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Email Progress</th>
                    <th className="w-48 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Email Status</th>
                    <th className="w-48 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Linkedin Progress</th>
                    <th className="w-48 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Action</th>
                </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
                {prospects.map(prospect => (
                    <ProspectsTableRow
                        key={prospect.company_id}
                        prospect={prospect}
                        isSelected={selectedRows[prospect.company_id] || false}
                        onRowSelect={onRowSelect}
                        onGenerate={onGenerate}
                        onReview={onReview}
                        onSend={onSend}
                        onSendLinked={onSendLinked}
                        getStatusStyle={getStatusStyle}
                    />
                ))}
            </tbody>
        </table>
    );
};

export default ProspectsTable;